'use strict';

angular.module('cvsApp')
    .factory('help', [ '$location', '$rootScope','$timeout',
    function ($location, $rootScope,$timeout) {
        var help = {}, userAgent, msie, iframeContainer;

         // Takes an OBJECT or STRING and wraps it in an array
        help.convertToArray = function (input) {
            var arr;

            if (Object.prototype.toString.call(input) === '[object Object]') {
                arr = [input];
            } else if (Object.prototype.toString.call(input) === '[object Array]') {
                arr = input
            } else if (Object.prototype.toString.call(input) === '[object String]') {
                arr = [input]
            }

            return arr;
        };

        help.returnUniqueArray = function (arrInput) {
            var arr = [];

            arrInput.forEach(function (element) {
                if (arr.indexOf(element) === -1) {
                    arr.push(element);
                }
            });

            return arr;
        };

        help.IEVersion = function () {
            if (msie) {
                return msie;
            }
            var arr = (/msie (\d+)/.exec(navigator.userAgent.toLowerCase()));
            msie = (arr || [])[1];

            if (isNaN(msie)) {
                arr = (/trident\/.*; rv:(\d+)/.exec(navigator.userAgent.toLowerCase()));
                msie = (arr || [])[1];
            }
            return msie;

        };

        help.getUserAgent = function (userAgentPickedUp) {
            if (userAgent) {
                return userAgent;
            }
            // ANDROID
            if (/Android/i.test(userAgentPickedUp)) {
                // ANDROID MOBILE
                if (/Mobile/i.test(userAgentPickedUp)) {
                    userAgent = 'AND_MOBILE';

                    // ANDROID GLASS
                } else if (/Glass/i.test(userAgentPickedUp)) {
                    userAgent = 'AND_GLASS';

                    // ANDROID TABLET
                } else {
                    userAgent = 'AND_TABLET';
                }
                // iOS Mobile
            } else if (/iPhone|iPod/i.test(userAgentPickedUp)) {
                userAgent = 'IOS_MOBILE';


                // iOS Tablet
            } else if (/iPad/i.test(userAgentPickedUp)) {
                userAgent = 'IOS_TABLET';


                // Windows
            } else if (/IEMobile/i.test(userAgentPickedUp)) {
                userAgent = 'WIN_MOBILE';

                // Other identified vendor
            } else if (/webOS|BlackBerry|Opera Mini/i.test(userAgentPickedUp)) {
                userAgent = 'OTH_MOBILE';
            }
            else {
                userAgent = 'DESKTOP';
            }
            return userAgent;
        };

        help.go = function (path) {
            $location.path(path);
        };

        help.currentLocation = function () {
            return $location.url();
        };

        help.emit = function (messageName) {
            $rootScope.$emit(messageName);
        };

        help.broadCast = function (messageName) {
            $rootScope.$broadcast(messageName);
        };

        help.executeOn = function (messageName, method) {
            $rootScope.$on(messageName, method);
        };



        help.getIframeData = function () {
            var iframeCol = $('iframe');
            angular.forEach(iframeCol, function (val) {
                if (val.contentDocument.body.id == 'cdc') {
                    iframeContainer = val;
                }
            });
            return iframeContainer;
        };

        help.sortList = function (listToSort, sortKey) {
            var reA = /[^a-zA-Z]/g;
            var reN = /\d+(\.\d+)?/g;
            listToSort.sort(function (alpha, beta) {
                var a=alpha[sortKey],
                b=beta[sortKey];
                var aA = a.replace(reA, "");
                var bA = b.replace(reA, "");
                if(aA === bA) {
                    var aN = a.match(reN)? parseFloat(a.match(reN)[0]):0;
                    var bN = b.match(reN)? parseFloat(b.match(reN)[0]):0;
                    return aN === bN ? 0 : aN > bN ? 1 : -1;
                } else {
                    return aA > bA ? 1 : -1;
                }
            });
        };

        help.setSessionStorage = function (key, data) {
            if (typeof(Storage) !== "undefined") {
                sessionStorage.setItem(key, JSON.stringify(data));
            }
        };

        help.getSessionStorage = function (key) {
            if (typeof(Storage) !== "undefined" && sessionStorage[key]) {
                return JSON.parse(sessionStorage[key]);
            }
            return false;
        };

        help.getDate = function (dateInput) {
            if(dateInput && (typeof dateInput=== 'string' ||dateInput instanceof String)){
                dateInput=dateInput.toString();
                var t = dateInput.split(/[- T]/);
                return new Date(t[0], t[1] - 1, t[2]);
            }else if(dateInput && (typeof dateInput=== 'object' ||dateInput instanceof Object)){
                dateInput=dateInput.__text;
                var t = dateInput.split(/[- T]/);
                return new Date(t[0], t[1] - 1, t[2]);
            }else{
                return dateInput;
            }
        };

        help.getEnvFromURL = function () {
            var url=$location.host();
            var envValues = ['dev1','dev2','dev3','sit1','sit2','sit3','prod','stp','cte','localhost'];
            for(var i=0;i<envValues.length;i++){
                if (url && url.indexOf(envValues[i])!==-1) {
                    return envValues[i];
                    break;
                }
            }
            return "sit1";
        };

        help.popOverHandler=function(element, event) {
            $timeout(function () {
                angular.element(element).popover(event);
                var bindClick = function (e) {
                    var $popover = $('[data-toggle=popover]').popover();
                    var isPopover = angular.element(e.target).is('[data-toggle=popover]'),
                        inPopover = angular.element(e.target).closest('.popover').length > 0;
                    if (!isPopover && !inPopover) {
                        $popover.popover('hide');
                    }
                };
                angular.element(document).on("click", bindClick);
                //TODO
               // angular.element(window.parent.document).on("click", bindClick);
            });
        };

        //TODO
         help.resetTimer=function(){
/*             if(parent && parent.clearWarning){
                 parent.clearWarning();
                 if(parent.RegisterTimeoutCVS && parent.warningPage && parent.logoffPage && parent.refreshPage){
                    //keep session alive by making a request.
                    var img = document.getElementById('sessionRefresh');
                    img.src = '/wps/images/info.gif?' + Math.random();
                    parent.RegisterTimeoutCVS(15,3,parent.warningPage,parent.logoffPage,parent.refreshPage);
                 }
             }*/
        };

        return help;
    }]);